import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { pageAnimation } from "../animate";
import ScrollTop from "../components/ScrollTop";
import TypeIt from "typeit";
import dataStructure from "../img/dataStructure.png";
import bro from "../img/bro.png";
import Duplicatebro from "../img/Duplicate-bro.png";
import CoursesDetail4 from "../components/CoursesDetail4";
import CourseDetail41 from "../components/CourseDetail41";

const DataStructure = () => {
  useEffect(() => {
    new TypeIt("#element", {
      strings: ["資料結構與演算法"],
      speed: 100,
      afterComplete: (instance) => {
        const el = document.querySelector("#element");
        const cursor = el?.querySelector(".ti-cursor");
        if (cursor) cursor.style.display = "none";
        return instance;
      },
    }).go();

    new TypeIt("#element2", {
      strings:
        "用JavaScript學習資料結構與演算法，內容包含排序演算法、主定理、連結串列、雜湊表、二元搜尋樹、優先佇列、霍夫曼演算法、最小生成樹、深度優先搜尋、寬度優先搜尋、最短路徑演算法、戴克斯特拉演算法、動態規劃等等。",
      speed: 15,
      startDelay: 1500,
      loop: false,
      afterComplete: (instance) => {
        const el = document.querySelector("#element2");
        const cursor = el?.querySelector(".ti-cursor");
        if (cursor) cursor.style.display = "none";
        return instance;
      },
    }).go();
  }, []);

  return (
    <div>
      <motion.div
        variants={pageAnimation}
        initial="hidden"
        animate="show"
        className="webdev"
        exit="exit"
      >
        <div className="img">
          <img src={dataStructure} alt="" />
        </div>
        <div className="desc">
          <h1>
            <span id="element"></span>
          </h1>
          <div className="content">
            <h3 id="element2"></h3>
          </div>
          <div>
            <p>
              課程價格: <span className="hide">新台幣$290</span>{" "}
            </p>
            <p>
              優惠代碼(點擊連結即可自動套用優惠碼):
              <br />
              <a
                target="_blank"
                href={`https://www.udemy.com/course/algorithm-data-structure/?couponCode=${process.env.REACT_APP_DATA_STRUCTURE_COUPON}`}
              >
                <span>{process.env.REACT_APP_DATA_STRUCTURE_COUPON}</span>
              </a>
              (只到
              <span style={{ color: "red" }}>{process.env.REACT_APP_DATE}</span>
              之前有效)
            </p>
            <p>
              課程連結:
              <br />
              <a
                target="_blank"
                href={`https://www.udemy.com/course/algorithm-data-structure/?couponCode=${process.env.REACT_APP_DATA_STRUCTURE_COUPON}`}
              >
                <span className="hide">
                  https://www.udemy.com/course/algorithm-data-structure/
                </span>
              </a>
            </p>
            {/* <p style={{ fontSize: "5px", opacity: "0.9" }} target="_blank">
              Hiskio 平台課程連結
              (無法使用優惠碼)：https://hiskio.com/courses/572/about
            </p> */}
          </div>
        </div>
        <CourseDetail41 img={bro} />
        <CoursesDetail4 img={Duplicatebro} />
        <ScrollTop />
      </motion.div>
    </div>
  );
};

export default DataStructure;
